import { Component, OnInit, ViewEncapsulation, ViewChild, Inject } from '@angular/core';
import { fuseAnimations } from '../../../../../../../../../core/animations';
import { Observable, Subscription } from 'rxjs';

import * as _ from 'lodash';
//Service files
import { SideNavService } from '../../../sidenav.service';

//Common components
import { ToastComponent } from '../../../../../../common/toast.component';

//Common values and models files
import { kpiDisplayValues } from '../../../../../../utils';
import { FetchAllKpiValues, KpiDataSets, kpiAllDataSets } from '../../../../../../models';

@Component({
  selector: 'spekwo-kpi',
  templateUrl: './kpi.component.html',
  styleUrls: ['./kpi.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class KpiComponent implements OnInit {

  displayValues = kpiDisplayValues;
  isKPIUpdated: Observable<boolean>;
  private _subscriptions: Subscription[] = [];

  allKpiDataDetails: kpiAllDataSets = Object.assign({}, initialKpiDataSet);
  currentMonthKpiValues: KpiDataSets = Object.assign({}, initialData);

  lastEditedMonth: number;
  lastEditedYear: number;
  monthToPush: number;
  yearToPush: number;
  currentDate: Date = new Date();

  kpiId: number;
  constructor(
    /** Local component */
    private toastComponent: ToastComponent,
    private _SideNavService: SideNavService,
  ) {
    this.isKPIUpdated = this._SideNavService.onKpiDetailsChanged.asObservable();
    this._SideNavService.fetchAllKpiData().then((response: FetchAllKpiValues) => { });
  }

  ngOnInit() {

    //Subscription to watch any changes happen in kpi values
    this._subscriptions.push(
      this._SideNavService.onKpiDetailsChanged.subscribe(response => {
        var LastEdited: Date;

        if (response) {
          if (response.allKpiList && response.allKpiList.length > 0) {
            //Assigning kpi details to local fields
            this.allKpiDataDetails.kpiDetails = Object.assign([], response.allKpiList);
            console.log("allkpi",this.allKpiDataDetails);
            this.kpiId = response.kpiId;
            LastEdited = new Date(response.lastEdited);
            this.lastEditedMonth = LastEdited.getMonth();
            this.lastEditedYear = LastEdited.getFullYear();
            // console.log("response", this.lastEditedMonth, this.lastEditedYear);
            //checking on current month is pushed or not
            if ((this.lastEditedMonth < this.currentDate.getMonth()) || (this.lastEditedYear < this.currentDate.getFullYear())) {
              this.pushKpivalues();
            }
          }else{
            this.createNewKpiSet();
          }
        }

      }, () => {

      })
    );


  }

  ngOnDestroy() {
    this._subscriptions.forEach(subscriptions => subscriptions.unsubscribe());
  }

  //Pusing monthly kpi report to an array
  pushKpivalues() {
    //Assigning current month and years
    this.monthToPush = (this.lastEditedMonth == 11) ? 0 : this.lastEditedMonth + 1;
    this.yearToPush = (this.lastEditedMonth == 11) ? this.lastEditedYear + 1 : this.lastEditedYear;
    //to get a count of month differnce
    var differedMonthsCount: number = this.getDifferMonths();
    //If any difference pushing empty datas with month and year to kpi list
    if (differedMonthsCount > 0) {
      var len=0;
      //To push empty month based on difference count
      for (let i = 0; i < differedMonthsCount; i++) {
        this.currentMonthKpiValues = Object.assign({}, initialData);
        this.currentMonthKpiValues.month = this.monthToPush;
        this.currentMonthKpiValues.year = this.yearToPush;
        this.allKpiDataDetails.kpiDetails.push(Object.assign({}, this.currentMonthKpiValues));
        this.currentMonthKpiValues = Object.assign({}, initialData);
        this.monthToPush += 1;
        //if month  go beyond the 11 assigning to jan and next year count
        if (this.monthToPush > 11) {
          this.monthToPush = 0;
          this.yearToPush += 1;
        }
        len++;
        if(len==differedMonthsCount){
          console.log("pushed value",this.allKpiDataDetails);
          this.onUpdateKpiDetail();
        }
      }
      // console.log("allkpidetailspushed", this.allKpiDataDetails);
    }
  }

  //To get difference b/w last edited and current month
  getDifferMonths() {
    var months;
    months = (this.currentDate.getFullYear() - this.lastEditedYear) * 12;
    months -= this.lastEditedMonth;
    months += this.currentDate.getMonth();
    console.log("month differed", months);
    return months <= 0 ? 0 : months;
  }

  //On save funcitonality
  onUpdateKpiDetail() {

    //Calling updating service function
    this._SideNavService.updateKpiDetailsById(this.allKpiDataDetails, this.kpiId).then((res) => {
      if (res) {
        this._SideNavService.fetchAllKpiData().then((response: FetchAllKpiValues) => { });
      }
    }, (err) => {
      console.log(err);
    });
  }

  //Create functionality
  createNewKpiSet() {
   console.log("create kpi0");
   this.currentMonthKpiValues = Object.assign({}, initialData);
   this.currentMonthKpiValues.month = new Date().getMonth();
   this.currentMonthKpiValues.year = new Date().getFullYear();
   this.allKpiDataDetails.kpiDetails.push(Object.assign({}, this.currentMonthKpiValues));
  console.log("allkpis",this.allKpiDataDetails);
    //Calling updating service function
    this._SideNavService.CreateKpiDetails(this.allKpiDataDetails).then((res) => {
      console.log("response", res);
      if (res) {
        this._SideNavService.fetchAllKpiData().then((response: FetchAllKpiValues) => { });
        // this.toastComponent.showToast('Values are saved successfully');
        //To get a updated values
        // this.formLoader = false;
        // this.getAllKpiValues();
      }
    }, (err) => {
      // this.formLoader = false;
      console.log(err);
    });
  }


}




const initialData: KpiDataSets = {
  fullSpekwo: {
    total: 0,
    itemRev: 0.00,
    grossRev: 0.00
  },
  spekCall: {
    total: 0,
    itemRev: 0.00,
    grossRev: 0.00
  },
  spekWalk: {
    total: 0,
    itemRev: 0.00,
    grossRev: 0.00
  },
  spekApproved: {
    total: 0,
    itemRev: 0.00,
    grossRev: 0.00
  },
  revenueForSpekPro: {
    total: 0,
    itemRev: 0.00,
    grossRev: 0.00
  },
  revenueForSpekInternalPro: 0.00,
  numberOfOutBoundCalls: 0,
  numberOfEmailCampaigns: 0,
  amtSpentLivePresent: 0.00,
  amtSpentFb: 0.00,
  amtSpentInsta: 0.00,
  amtSpentLinkedIn: 0.00,
  date: new Date(),
  month: null,
  year: null
}

const initialKpiDataSet: kpiAllDataSets = {
  kpiDetails: []
}





// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/kpi/kpi.component.ts